import React, { useState, useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";
import { NumericFormat } from "react-number-format";
import Select from "react-select";
import useDebouncedEffect from "use-debounced-effect";
import axios from "axios";
import { clientBranRetrieve } from "../../../text/apidata";
import {
    getHrmsConnectivityListAction,
    setHrmsConnectivityUpdateAction,
    setHrmsConnectivityStatusUpdateAction,
    setClientBranchSearchAction,
    getRoleListActions,
    setZoneActions,
} from "../../../Redux/Slice";

const ATHENA_ORG_ID = "28e108e0-a644-4365-89df-317867f00f22";

// division_level is a list of strings; older records may still hold a single string
const toDivisionLevelList = (value) =>
  Array.isArray(value) ? value : value ? [value] : [];

const HrmsJodOffer = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { emoloyeeId } = useParams();
    const state = useSelector((state) => state);
    // only payroll (0), regional manager (1) and super admin (3) can edit division level
    const canEditDivisionLevel = ["0", "1", "3"].includes(
        String(state.ClientBranchIDs.SUBROLE),
    );

    // Find the item matching current employee ID
    const rawData = state?.hrmsConnectivityList?.hrmsConnectivityListData;

    const item = useMemo(() => {
        if (Array.isArray(rawData) && rawData.length > 0) {
            return rawData.find((el) => String(el?.id) === String(emoloyeeId) || String(el?.user_id?.id) === String(emoloyeeId)) || (rawData.length === 1 ? rawData[0] : null);
        } else if (rawData && typeof rawData === "object" && !Array.isArray(rawData)) {
            return rawData;
        }
        return null;
    }, [rawData, emoloyeeId]);
    console.log(item, "asjhdaskdjas")

    const [siteOptions, setSiteOptions] = useState([]);
    const [clientOptions, setClientOptions] = useState([]);
    const [roleOptions, setRoleOptions] = useState([]);

    const [siteValue, setSiteValue] = useState(null);
    const [clientValue, setClientValue] = useState(null);
    const [roleValue, setRoleValue] = useState(null);

    const [addbasic, setthebasic] = useState(true);

    const [searchState, setSearchState] = useState({
        siteSearch: "",
        clientSearch: "",
        roleSearch: "",
    });

    const [debouncedSearch, setDebouncedSearch] = useState({
        siteSearch: "",
        clientSearch: "",
        roleSearch: "",
    });

    const [data, setData] = useState({
        site_id: "",
        client_id: "",
        designation_id: "",
        gross_salary: "",
        product_code: "",
        division_level: "",
        joining_bonus: "",
        entertainment_reimbursement: "",
        Stipend: "",
        advance_bonus: "",
        mobile_expenses: "",
        conveyance: "",
        is_gratuity: false,
        // Basic Salary fields
        basic_salary: "",
        hra_salary: "",
        other_allowances_salary: "",
        employee_ESI: "",
        employee_PF: "",
        airtime_allowance: "",
        net_salary: "",
    });

    const [siteError, setSiteError] = useState("");
    const [clientError, setClientError] = useState("");
    const [designationError, setDesignationError] = useState("");
    const [grossSalaryError, setGrossSalaryError] = useState("");
    const [mobileExpensesError, setMobileExpensesError] = useState("");
    const [conveyanceError, setConveyanceError] = useState("");
    const [basicError, setBasicError] = useState("");
    const [hraError, setHraError] = useState("");
    const [otherError, setOtherError] = useState("");
    const [esiError, setEsiError] = useState("");
    const [pfError, setPfError] = useState("");
    const [airtimeError, setAirtimeError] = useState("");
    const [netSalaryError, setNetSalaryError] = useState("");
    const [divisionLevelError, setDivisionLevelError] = useState("");

    // division level options come from the selected client
    const [divisionLevelOptions, setDivisionLevelOptions] = useState([]);

    useEffect(() => {
        setDivisionLevelOptions([]);
        if (!data.client_id) {
            return;
        }
        let ignore = false;
        axios({
            method: "get",
            url: clientBranRetrieve + data.client_id + "/",
            headers: {
                Authorization: "Bearer " + state.users.UserData.session.token,
            },
        })
            .then((response) => {
                if (!ignore) {
                    setDivisionLevelOptions(
                        toDivisionLevelList(response.data.data?.division_level).map(
                            (level) => ({ value: level, label: level }),
                        ),
                    );
                }
            })
            .catch(() => {});
        return () => {
            ignore = true;
        };
    }, [data.client_id]);

    // Fetch employee data unconditionally on mount or ID change
    useEffect(() => {
        if (emoloyeeId) {
            dispatch(getHrmsConnectivityListAction({ employee_timeline_id: emoloyeeId }));
        }
    }, [emoloyeeId, dispatch]);

    // Prefill form data immediately when item is available
    useEffect(() => {
        if (item) {
            const jobDesc = item?.job_description || {};

            // Site (Zone)
            const siteId =
                jobDesc?.site_id?.id ||
                jobDesc?.site_id ||
                item?.site_id?.id ||
                item?.site_id ||
                item?.user_id?.zone_id?.[0]?.id ||
                "";
            const siteName =
                jobDesc?.site_id?.zone_name ||
                jobDesc?.site_name ||
                item?.site_id?.zone_name ||
                item?.user_id?.zone_id?.[0]?.zone_name ||
                "";

            // Client
            const clientId =
                item?.client_id?.id ||
                item?.client_id?.value ||
                (typeof item?.client_id === "string" ? item?.client_id : "") ||
                jobDesc?.client_id?.id ||
                "";
            const clientName =
                item?.client_id?.client_name ||
                item?.client_id?.label ||
                jobDesc?.client_id?.client_name ||
                "";

            // Designation
            const designationId =
                jobDesc?.designation_id?.id ||
                (typeof jobDesc?.designation_id === "string" ? jobDesc?.designation_id : "") ||
                "";
            const designationRole =
                jobDesc?.designation_id?.role ||
                jobDesc?.designation_name ||
                "";

            const hasBasicSalary = Boolean(
                jobDesc?.basic_salary ||
                jobDesc?.hra_salary ||
                jobDesc?.other_allowances_salary ||
                jobDesc?.employee_ESI ||
                jobDesc?.employee_PF ||
                jobDesc?.airtime_allowance ||
                jobDesc?.net_salary
            );

            setthebasic(hasBasicSalary);

            setData({
                site_id: siteId,
                client_id: clientId,
                designation_id: designationId,
                gross_salary: jobDesc?.gross_salary ?? "",
                product_code: jobDesc?.product_code ?? "",
                division_level: jobDesc?.division_level ?? "",
                joining_bonus: jobDesc?.joining_bonus ?? "",
                entertainment_reimbursement: jobDesc?.entertainment_reimbursement ?? "",
                Stipend: jobDesc?.Stipend ?? jobDesc?.stipend ?? "",
                advance_bonus: jobDesc?.advance_bonus ?? "",
                mobile_expenses: jobDesc?.mobile_expenses ?? "",
                conveyance: jobDesc?.conveyance ?? "",
                is_gratuity: Boolean(jobDesc?.is_gratuity),
                basic_salary: jobDesc?.basic_salary ?? "",
                hra_salary: jobDesc?.hra_salary ?? "",
                other_allowances_salary: jobDesc?.other_allowances_salary ?? "",
                employee_ESI: jobDesc?.employee_ESI ?? "",
                employee_PF: jobDesc?.employee_PF ?? "",
                airtime_allowance: jobDesc?.airtime_allowance ?? "",
                net_salary: jobDesc?.net_salary ?? "",
            });

            if (siteId) {
                const sObj = { value: siteId, label: siteName ? siteName.toUpperCase() : String(siteId) };
                setSiteValue(sObj);
                setSiteOptions((prev) => (prev.some((o) => o.value === siteId) ? prev : [sObj, ...prev]));
            }

            if (clientId) {
                const cObj = { value: clientId, label: clientName ? clientName.toUpperCase() : String(clientId) };
                setClientValue(cObj);
                setClientOptions((prev) => (prev.some((o) => o.value === clientId) ? prev : [cObj, ...prev]));
            }

            if (designationId) {
                const rObj = { value: designationId, label: designationRole ? designationRole.toUpperCase() : String(designationId) };
                setRoleValue(rObj);
                setRoleOptions((prev) => (prev.some((o) => o.value === designationId) ? prev : [rObj, ...prev]));
            }
        }
    }, [item]);

    // Debounce user typing
    useDebouncedEffect(
        () => {
            setDebouncedSearch(searchState);
        },
        400,
        [searchState]
    );

    // Search Sites (Zones) when user types
    useEffect(() => {
        if (debouncedSearch.siteSearch) {
            dispatch(
                setZoneActions({
                    search: debouncedSearch.siteSearch,
                    page_size: 20,
                    page: 1,
                    counts: 4,
                })
            );
        }
    }, [debouncedSearch.siteSearch, dispatch]);

    useEffect(() => {
        if (state?.ZonePart?.Zone && Array.isArray(state.ZonePart.Zone)) {
            const options = state.ZonePart.Zone.map((el) => ({
                value: el.id,
                label: (el.zone_name || "").toUpperCase(),
            }));
            setSiteOptions(options);
        }
    }, [state?.ZonePart?.Zone]);

    // Search Clients when user types
    useEffect(() => {
        if (debouncedSearch.clientSearch) {
            dispatch(
                setClientBranchSearchAction({
                    search: debouncedSearch.clientSearch,
                    page_size: 20,
                    page: 1,
                    org_ids: ATHENA_ORG_ID,
                })
            );
        }
    }, [debouncedSearch.clientSearch, dispatch]);

    useEffect(() => {
        if (state?.BranchSearchpart?.BranchSearch && Array.isArray(state.BranchSearchpart.BranchSearch)) {
            const options = state.BranchSearchpart.BranchSearch.map((el) => ({
                value: el.id,
                label: (el.client_name || "").toUpperCase(),
            }));
            setClientOptions(options);
        }
    }, [state?.BranchSearchpart?.BranchSearch]);

    // Search Roles when user types or client changes
    useEffect(() => {
        if (data.client_id) {
            dispatch(
                getRoleListActions({
                    search: debouncedSearch.roleSearch || "",
                    page_size: 100,
                    page: 1,
                    client: data.client_id,
                    white_collar: false,
                })
            );
        }
    }, [data.client_id, debouncedSearch.roleSearch, dispatch]);

    useEffect(() => {
        if (state?.rolelists?.RoleList && Array.isArray(state.rolelists.RoleList)) {
            const options = state.rolelists.RoleList.map((el) => ({
                value: el.id,
                label: (el.role || "").toUpperCase(),
            }));
            setRoleOptions(options);
        }
    }, [state?.rolelists?.RoleList]);

    const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;
        setData((prev) => ({
            ...prev,
            [name]: type === "checkbox" ? checked : value,
        }));
    };

    const handleSiteChange = (selected) => {
        setSiteValue(selected);
        setData((prev) => ({
            ...prev,
            site_id: selected ? selected.value : "",
        }));
        setSiteError("");
    };

    const handleClientChange = (selected) => {
        setClientValue(selected);
        setData((prev) => ({
            ...prev,
            client_id: selected ? selected.value : "",
            designation_id: "",
        }));
        setRoleValue(null);
        setClientError("");
    };

    const handleRoleChange = (selected) => {
        setRoleValue(selected);
        setData((prev) => ({
            ...prev,
            designation_id: selected ? selected.value : "",
        }));
        setDesignationError("");
    };

    const validate = () => {
        let isValid = true;

        if (!data.client_id) {
            setClientError("*Client is required");
            isValid = false;
        } else {
            setClientError("");
        }

        if (!data.designation_id) {
            setDesignationError("*Designation is required");
            isValid = false;
        } else {
            setDesignationError("");
        }

        if (data.gross_salary === "" || data.gross_salary === null || data.gross_salary === undefined) {
            setGrossSalaryError("*Indicative Salary is required");
            isValid = false;
        } else if (Number(data.gross_salary) <= 0) {
            setGrossSalaryError("*Indicative Salary must be greater than 0");
            isValid = false;
        } else if (String(data.gross_salary).length > 8) {
            setGrossSalaryError("*Indicative Salary cannot exceed 8 digits");
            isValid = false;
        } else {
            setGrossSalaryError("");
        }

        if (data.mobile_expenses === "" || data.mobile_expenses === null || data.mobile_expenses === undefined) {
            setMobileExpensesError("*Mobile Expenses is required");
            isValid = false;
        } else {
            setMobileExpensesError("");
        }

        if (data.conveyance === "" || data.conveyance === null || data.conveyance === undefined) {
            setConveyanceError("*Conveyance is required");
            isValid = false;
        } else {
            setConveyanceError("");
        }

        if (
            canEditDivisionLevel &&
            divisionLevelOptions.length > 0 &&
            toDivisionLevelList(data.division_level).length === 0
        ) {
            setDivisionLevelError("*Division Level is required");
            isValid = false;
        } else {
            setDivisionLevelError("");
        }

        return isValid;
    };

    const handleSubmit = (e) => {
        e?.preventDefault();

        if (!validate()) {
            return;
        }

        const userId = emoloyeeId;

        const payload = {
            id: userId,
            // user_id: userId,
            // timeline_id: item?.id || emoloyeeId,
            site_id: data.site_id || undefined,
            client_id: data.client_id,
            designation_id: data.designation_id,
            gross_salary: data.gross_salary !== "" && data.gross_salary !== null && data.gross_salary !== undefined ? Number(data.gross_salary) : 0,
            product_code: data.product_code || "",
            division_level: toDivisionLevelList(data.division_level).slice(0, 1),
            joining_bonus: data.joining_bonus !== "" && data.joining_bonus !== null && data.joining_bonus !== undefined ? Number(data.joining_bonus) : 0,
            entertainment_reimbursement: data.entertainment_reimbursement !== "" && data.entertainment_reimbursement !== null && data.entertainment_reimbursement !== undefined ? Number(data.entertainment_reimbursement) : 0,
            Stipend: data.Stipend !== "" && data.Stipend !== null && data.Stipend !== undefined ? Number(data.Stipend) : 0,
            advance_bonus: data.advance_bonus !== "" && data.advance_bonus !== null && data.advance_bonus !== undefined ? Number(data.advance_bonus) : 0,
            mobile_expenses: data.mobile_expenses !== "" && data.mobile_expenses !== null && data.mobile_expenses !== undefined ? Number(data.mobile_expenses) : 0,
            conveyance: data.conveyance !== "" && data.conveyance !== null && data.conveyance !== undefined ? Number(data.conveyance) : 0,
            // is_gratuity: Boolean(data.is_gratuity),
            basic_salary: addbasic && data.basic_salary !== "" && data.basic_salary !== null && data.basic_salary !== undefined ? Number(data.basic_salary) : 0,
            hra_salary: addbasic && data.hra_salary !== "" && data.hra_salary !== null && data.hra_salary !== undefined ? Number(data.hra_salary) : 0,
            other_allowances_salary: addbasic && data.other_allowances_salary !== "" && data.other_allowances_salary !== null && data.other_allowances_salary !== undefined ? Number(data.other_allowances_salary) : 0,
            employee_ESI: addbasic && data.employee_ESI !== "" && data.employee_ESI !== null && data.employee_ESI !== undefined ? Number(data.employee_ESI) : 0,
            employee_PF: addbasic && data.employee_PF !== "" && data.employee_PF !== null && data.employee_PF !== undefined ? Number(data.employee_PF) : 0,
            airtime_allowance: addbasic && data.airtime_allowance !== "" && data.airtime_allowance !== null && data.airtime_allowance !== undefined ? Number(data.airtime_allowance) : 0,
            net_salary: addbasic && data.net_salary !== "" && data.net_salary !== null && data.net_salary !== undefined ? Number(data.net_salary) : 0,

        };

        dispatch(setHrmsConnectivityUpdateAction(payload));
    };

    const handlePushToHrms = () => {
        const userId = emoloyeeId;
        const payload = {
            id: userId,
            is_hrms_pushed: true,
            navigate: navigate,
        };
        dispatch(setHrmsConnectivityStatusUpdateAction(payload));
    };

    return (
        <div style={{ width: "100%", margin: "10px 0 25px 0" }}>
            {/* Orange Header Card */}
            <div
                style={{
                    background: "#F26239",
                    color: "#ffffff",
                    padding: "12px 20px",
                    borderTopLeftRadius: "6px",
                    borderTopRightRadius: "6px",
                    fontSize: "16px",
                    fontWeight: "600",
                }}
            >
                Job Information
            </div>

            {/* Form Body */}
            <div
                style={{
                    background: "#ffffff",
                    border: "1px solid #e0e0e0",
                    borderTop: "none",
                    borderBottomLeftRadius: "6px",
                    borderBottomRightRadius: "6px",
                    padding: "20px 24px 30px",
                    boxShadow: "0 2px 6px rgba(0,0,0,0.04)",
                }}
            >
                <div className="row">
                    {/* Row 1 */}
                    {/* 1. Site */}
                    <div className="col-sm-3 mt-3">
                        <label className="form-label" htmlFor="siteSelect">
                            Site <span style={{ color: "red" }}>*</span>
                        </label>
                        <Select
                            id="siteSelect"
                            className="Selects"
                            options={siteOptions}
                            value={siteValue}
                            onChange={handleSiteChange}
                            onInputChange={(val) =>
                                setSearchState((prev) => ({ ...prev, siteSearch: val }))
                            }
                            placeholder="Select"
                            isDisabled
                        />
                        <p className="Error" style={{ marginLeft: "-5px" }}>{siteError}</p>
                    </div>

                    {/* 2. Client */}
                    <div className="col-sm-3 mt-3">
                        <label className="form-label" htmlFor="clientSelect">
                            Client <span style={{ color: "red" }}>*</span>
                        </label>
                        <Select
                            id="clientSelect"
                            className="Selects"
                            options={clientOptions}
                            value={clientValue}
                            onChange={handleClientChange}
                            onInputChange={(val) =>
                                setSearchState((prev) => ({ ...prev, clientSearch: val }))
                            }
                            isDisabled

                        />
                        <p className="Error" style={{ marginLeft: "-5px" }}>{clientError}</p>
                    </div>

                    {/* 3. Designation */}
                    <div className="col-sm-3 mt-3">
                        <label className="form-label" htmlFor="designationSelect">
                            Designation <span style={{ color: "red" }}>*</span>
                        </label>
                        <Select
                            id="designationSelect"
                            className="Selects stateNames"
                            options={roleOptions}
                            value={roleValue}
                            onChange={handleRoleChange}
                            onInputChange={(val) =>
                                setSearchState((prev) => ({ ...prev, roleSearch: val }))
                            }
                            placeholder="Select"
                            isDisabled
                        />
                        <p className="Error" style={{ marginLeft: "-5px" }}>{designationError}</p>
                    </div>

                    {/* 4. Indicative Salary */}
                    <div className="col-sm-3 mt-3">
                        <label className="form-label">
                            Indicative Salary <span style={{ color: "red" }}>*</span>
                        </label>
                        <NumericFormat
                            thousandSeparator={true}
                            className="form-control FormalFiledReport"
                            value={data.gross_salary}
                            onValueChange={(values) => {
                                const { value } = values;
                                if (value.length > 8) {
                                    setGrossSalaryError("*Indicative Salary cannot exceed 8 digits");
                                    return;
                                }
                                setGrossSalaryError("");
                                setData((prev) => ({
                                    ...prev,
                                    gross_salary: value,
                                }));
                            }}
                            autoComplete="off"
                            name="gross_salary"
                            isNumericString
                            displayType={"input"}
                        />
                        <p className="Error" style={{ marginLeft: "-5px" }}>{grossSalaryError}</p>
                    </div>

                    {/* Row 2 */}
                    {/* 5. Product Code */}
                    <div className="col-sm-3 mt-3">
                        <label className="form-label">
                            Product Code <span style={{ color: "red" }}>*</span>
                        </label>
                        <input
                            type="text"
                            className="form-control"
                            name="product_code"
                            value={data.product_code}
                            disabled
                            style={{ background: "#e9ecef" }}
                            autoComplete="off"
                        />
                    </div>

                    {/* 6. Division Level */}
                    <div className="col-sm-3 mt-3">
                        <label className="form-label">
                            Division Level <span style={{ color: "red" }}>*</span>
                        </label>
                        <Select
                            className="Selects stateNames"
                            placeholder="Select"
                            isClearable
                            options={divisionLevelOptions}
                            isDisabled={!canEditDivisionLevel}
                            // single select, but still stored as a one-item list for the payload
                            value={
                                toDivisionLevelList(data.division_level).map((level) => ({
                                    value: level,
                                    label: level,
                                }))[0] || null
                            }
                            onChange={(selected) => {
                                setData((prev) => ({
                                    ...prev,
                                    division_level: selected ? [selected.value] : [],
                                }));
                                setDivisionLevelError("");
                            }}
                        />
                        <p className="Error" style={{ marginLeft: "-5px" }}>{divisionLevelError}</p>
                    </div>

                    {/* 7. Joining Bonus */}
                    <div className="col-sm-3 mt-3">
                        <label className="form-label">
                            Joining Bonus
                        </label>
                        <input
                            type="number"
                            className="form-control"
                            name="joining_bonus"
                            value={data.joining_bonus}
                            onChange={handleInputChange}
                            autoComplete="off"
                        />
                    </div>

                    {/* 8. Entertainment Reimbursement */}
                    <div className="col-sm-3 mt-3">
                        <label className="form-label">
                            Entertainment Reimbursement
                        </label>
                        <input
                            type="number"
                            className="form-control"
                            name="entertainment_reimbursement"
                            value={data.entertainment_reimbursement}
                            onChange={handleInputChange}
                            autoComplete="off"
                        />
                    </div>

                    {/* Row 3 */}
                    {/* 9. Stipend */}
                    <div className="col-sm-3 mt-3">
                        <label className="form-label">
                            Stipend
                        </label>
                        <input
                            type="number"
                            className="form-control"
                            name="Stipend"
                            value={data.Stipend}
                            onChange={handleInputChange}
                            autoComplete="off"
                        />
                    </div>

                    {/* 10. Advance Bonus */}
                    <div className="col-sm-3 mt-3">
                        <label className="form-label">
                            Advance Bonus
                        </label>
                        <input
                            type="number"
                            className="form-control"
                            name="advance_bonus"
                            value={data.advance_bonus}
                            onChange={handleInputChange}
                            autoComplete="off"
                        />
                    </div>

                    {/* 11. Mobile Expenses */}
                    <div className="col-sm-3 mt-3">
                        <label className="form-label">
                            Mobile Expenses <span style={{ color: "red" }}>*</span>
                        </label>
                        <input
                            type="number"
                            className="form-control"
                            name="mobile_expenses"
                            value={data.mobile_expenses}
                            onChange={(e) => {
                                handleInputChange(e);
                                setMobileExpensesError("");
                            }}
                            autoComplete="off"
                        />
                        <p className="Error" style={{ marginLeft: "-5px" }}>{mobileExpensesError}</p>
                    </div>

                    {/* 12. Conveyance Reimbursement */}
                    <div className="col-sm-3 mt-3">
                        <label className="form-label">
                            Conveyance Reimbursement <span style={{ color: "red" }}>*</span>
                        </label>
                        <input
                            type="number"
                            className="form-control"
                            name="conveyance"
                            value={data.conveyance}
                            onChange={(e) => {
                                handleInputChange(e);
                                setConveyanceError("");
                            }}
                            autoComplete="off"
                        />
                        <p className="Error" style={{ marginLeft: "-5px" }}>{conveyanceError}</p>
                    </div>

                    {/* Row 4 */}
                    {/* 13. Gratuity */}
                    {/* <div className="col-sm-3 mt-3" style={{ display: "flex", alignItems: "center", gap: "12px", paddingTop: "25px" }}>
                        <label className="form-label mb-0" htmlFor="is_gratuity_check" style={{ cursor: "pointer" }}>
                            Gratuity
                        </label>
                        <input
                            id="is_gratuity_check"
                            className="form-check-input mt-0"
                            type="checkbox"
                            name="is_gratuity"
                            checked={Boolean(data.is_gratuity)}
                            onChange={handleInputChange}
                            style={{ width: "18px", height: "18px", cursor: "pointer" }}
                        />
                    </div> */}

                    {/* 14. Add Basic Salary */}
                    <div className="col-sm-3 mt-3" style={{ display: "flex", alignItems: "center", gap: "12px", paddingTop: "10px", paddingLeft: "40px" }}>
                        <label className="form-label mb-0" htmlFor="add_basic_salary_check" style={{ cursor: "pointer" }}>
                            Add Basic Salary
                        </label>
                        <input
                            id="add_basic_salary_check"
                            className="form-check-input mt-0"
                            type="checkbox"
                            checked={addbasic}
                            onChange={(e) => {
                                const checked = e.target.checked;
                                setthebasic(checked);
                                if (!checked) {
                                    setData((prev) => ({
                                        ...prev,
                                        other_allowances_salary: "",
                                        net_salary: "",
                                        hra_salary: "",
                                        employee_PF: "",
                                        employee_ESI: "",
                                        basic_salary: "",
                                        airtime_allowance: "",
                                    }));
                                    setBasicError("");
                                    setHraError("");
                                    setOtherError("");
                                    setEsiError("");
                                    setPfError("");
                                    setAirtimeError("");
                                    setNetSalaryError("");
                                }
                            }}
                            style={{ width: "18px", height: "18px", cursor: "pointer" }}
                        />
                    </div>

                    {/* Basic Salary Breakdown Fields - Rendered only when Add Basic Salary is true */}
                    {addbasic && (
                        <>
                            {/* 15. Basic Salary */}
                            <div className="col-sm-3 mt-3">
                                <label className="form-label">
                                    Basic Salary
                                </label>
                                <NumericFormat
                                    thousandSeparator={true}
                                    className="form-control FormalFiledReport"
                                    value={data.basic_salary}
                                    onValueChange={(values) => {
                                        const { value } = values;
                                        if (value.length > 8) {
                                            setBasicError("*Basic Salary cannot exceed 8 digits.");
                                            return;
                                        }
                                        setBasicError("");
                                        setData((prev) => ({
                                            ...prev,
                                            basic_salary: value,
                                        }));
                                    }}
                                    autoComplete="off"
                                    name="basic_salary"
                                    isNumericString
                                    displayType={"input"}
                                />
                                <p className="Error" style={{ marginLeft: "-5px" }}>{basicError}</p>
                            </div>

                            {/* 16. HRA */}
                            <div className="col-sm-3 mt-3">
                                <label className="form-label">
                                    HRA
                                </label>
                                <NumericFormat
                                    thousandSeparator={true}
                                    className="form-control FormalFiledReport"
                                    value={data.hra_salary}
                                    onValueChange={(values) => {
                                        const { value } = values;
                                        if (value.length > 8) {
                                            setHraError("*HRA Salary cannot exceed 8 digits.");
                                            return;
                                        }
                                        setHraError("");
                                        setData((prev) => ({
                                            ...prev,
                                            hra_salary: value,
                                        }));
                                    }}
                                    autoComplete="off"
                                    name="hra_salary"
                                    isNumericString
                                    displayType={"input"}
                                />
                                <p className="Error" style={{ marginLeft: "-5px" }}>{hraError}</p>
                            </div>

                            {/* 17. Other Allowances */}
                            <div className="col-sm-3 mt-3">
                                <label className="form-label">
                                    Other Allowances
                                </label>
                                <NumericFormat
                                    thousandSeparator={true}
                                    className="form-control FormalFiledReport"
                                    value={data.other_allowances_salary}
                                    onValueChange={(values) => {
                                        const { value } = values;
                                        if (value.length > 8) {
                                            setOtherError("*Other Allowances cannot exceed 8 digits.");
                                            return;
                                        }
                                        setOtherError("");
                                        setData((prev) => ({
                                            ...prev,
                                            other_allowances_salary: value,
                                        }));
                                    }}
                                    autoComplete="off"
                                    name="other_allowances_salary"
                                    isNumericString
                                    displayType={"input"}
                                />
                                <p className="Error" style={{ marginLeft: "-5px" }}>{otherError}</p>
                            </div>

                            {/* 18. Employee ESI */}
                            <div className="col-sm-3 mt-3">
                                <label className="form-label">
                                    Employee ESI
                                </label>
                                <NumericFormat
                                    thousandSeparator={true}
                                    className="form-control FormalFiledReport"
                                    value={data.employee_ESI}
                                    onValueChange={(values) => {
                                        const { value } = values;
                                        if (value.length > 8) {
                                            setEsiError("*ESI cannot exceed 8 digits.");
                                            return;
                                        }
                                        setEsiError("");
                                        setData((prev) => ({
                                            ...prev,
                                            employee_ESI: value,
                                        }));
                                    }}
                                    autoComplete="off"
                                    name="employee_ESI"
                                    isNumericString
                                    displayType={"input"}
                                />
                                <p className="Error" style={{ marginLeft: "-5px" }}>{esiError}</p>
                            </div>

                            {/* 19. Employee PF */}
                            <div className="col-sm-3 mt-3">
                                <label className="form-label">
                                    Employee PF
                                </label>
                                <NumericFormat
                                    thousandSeparator={true}
                                    className="form-control FormalFiledReport"
                                    value={data.employee_PF}
                                    onValueChange={(values) => {
                                        const { value } = values;
                                        if (value.length > 8) {
                                            setPfError("*PF cannot exceed 8 digits.");
                                            return;
                                        }
                                        setPfError("");
                                        setData((prev) => ({
                                            ...prev,
                                            employee_PF: value,
                                        }));
                                    }}
                                    autoComplete="off"
                                    name="employee_PF"
                                    isNumericString
                                    displayType={"input"}
                                />
                                <p className="Error" style={{ marginLeft: "-5px" }}>{pfError}</p>
                            </div>

                            {/* 20. Airtime Allowance */}
                            <div className="col-sm-3 mt-3">
                                <label className="form-label">
                                    Airtime Allowance
                                </label>
                                <NumericFormat
                                    thousandSeparator={true}
                                    className="form-control FormalFiledReport"
                                    value={data.airtime_allowance}
                                    onValueChange={(values) => {
                                        const { value } = values;
                                        if (value.length > 8) {
                                            setAirtimeError("*Airtime Allowance cannot exceed 8 digits.");
                                            return;
                                        }
                                        setAirtimeError("");
                                        setData((prev) => ({
                                            ...prev,
                                            airtime_allowance: value,
                                        }));
                                    }}
                                    autoComplete="off"
                                    name="airtime_allowance"
                                    isNumericString
                                    displayType={"input"}
                                />
                                <p className="Error" style={{ marginLeft: "-5px" }}>{airtimeError}</p>
                            </div>

                            {/* 21. Net Salary */}
                            <div className="col-sm-3 mt-3">
                                <label className="form-label">
                                    Net Salary
                                </label>
                                <NumericFormat
                                    thousandSeparator={true}
                                    className="form-control FormalFiledReport"
                                    value={data.net_salary}
                                    onValueChange={(values) => {
                                        const { value } = values;
                                        if (value.length > 8) {
                                            setNetSalaryError("*Net Salary cannot exceed 8 digits.");
                                            return;
                                        }
                                        setNetSalaryError("");
                                        setData((prev) => ({
                                            ...prev,
                                            net_salary: value,
                                        }));
                                    }}
                                    autoComplete="off"
                                    name="net_salary"
                                    isNumericString
                                    displayType={"input"}
                                />
                                <p className="Error" style={{ marginLeft: "-5px" }}>{netSalaryError}</p>
                            </div>
                        </>
                    )}
                </div>

                {/* Bottom Action Buttons */}
                {item?.is_hrms_pushed ?
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "flex-end",
                            gap: "12px",
                            marginTop: "35px",
                            paddingTop: "15px",
                            color: "green",
                            fontSize: "18px",
                            fontWeight: "bold"
                        }}
                    >HRMS Updated
                    </div> :
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "flex-end",
                            gap: "12px",
                            marginTop: "35px",
                            paddingTop: "15px",
                        }}
                    >

                        <button
                            type="button"
                            className="btn ButtonCSS"
                            style={{
                                color: "#ffffff",
                                background: "#EF4D39",
                                border: "none",
                                borderRadius: "5px",
                                padding: "7px 22px",
                                fontWeight: "500",
                            }}
                            onClick={handleSubmit}
                        >
                            Save
                        </button>
                        <button
                            type="button"
                            className="btn ButtonCSS"
                            style={{
                                color: "#ffffff",
                                background: "#4CAF50",
                                border: "none",
                                borderRadius: "5px",
                                padding: "7px 22px",
                                fontWeight: "500",
                            }}
                            onClick={handlePushToHrms}
                        >
                            Push
                        </button>
                    </div>}
            </div>
        </div>
    );
};

export default HrmsJodOffer;